//import logo, { ReactComponent } from './logo.svg';
import "./App.css";
import React, { useState, useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import HeaderBar from "./Components/Header/HeaderBar";
import FooterBar from './Components/Footer/FooterBar';
import Home from "./WebPages/Home";
import ProductList from "./WebPages/ProductListQuery";
//import ProductList from './WebPages/ProductListQueryObserver';
import ProductDetail from "./WebPages/ProductDetail";
import ShoppingCart from "./WebPages/ShoppingCart";
//import ShoppingCart from "./WebPages/ShoppingCartOLD";
import Profile from "./WebPages/Profile";
import Register from "./WebPages/Register";
import ThankYou from "./WebPages/ThankYou";
import ContactPage from "./WebPages/ContactPage";
import ConditionsPage from "./WebPages/ConditionsPage";
import g_cfg from "./config";

import LoginPage from "./WebPages/LoginPage";
import PasswordRecovery from "./WebPages/PasswordRecovery";
//import AuthContext from "./store/auth-context";

//const queryClient = new QueryClient();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: true,
      refetchOnReconnect: true,
      retry: true,
      staleTime: 15 * 60 * 1000, // 15 min
    },
  },
});

function App() {
  //const authCtx = useContext(AuthContext);
  const history = useHistory();

  const [Token, setToken] = useState(null);
  const [SessionKey, setSessionKey] = useState(null);
  const [IsTokenLoading, setIsTokenLoading] = useState(false);
  const [IsSessionKeyLoading, setIsSessionKeyLoading] = useState(false);
  const [IsFetchingFilters, setIsFetchingFilters] = useState(false);
  const [IsFetchingCart, setIsFetchingCart] = useState(false);
  const [CartData, setCartData] = useState(null);
  const [UserData, setUserData] = useState(null);
  const [Wishlist, setWishlist] = useState(null);
  const [ProductFilters, setProductFilters] = useState(null);

  const [ProvinceList, setProvinceList] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [IsWishLoading, setWishIsLoading] = useState(false);
  const [WishnetError, setWishNetError] = useState(null);

  if (UserData === null) {
    let uData = localStorage.getItem("storedUserData");
    if (uData !== null) {
      setUserData(JSON.parse(uData));
    }
  }

  function getUserWishlist(uData) {
    let params = [
      {
        name: "id_e_user",
        value: uData.id_e_user ? uData.id_e_user.toString() : "0",
      },
    ];
    wsCall(
      "https://ws.mediatoys.it/cliente/leggi_prodotti_preferiti",
      IsWishLoading,
      setWishIsLoading,
      WishnetError,
      setWishNetError,
      params,
      (respData) => {
        if (respData.status === "true") {
          setWishlist(respData.data);
        } else {
          setWishlist({ id_e_produtcs_list: [], e_products_list: [] });
        }
        //        localStorage.setItem("storedWishlist", JSON.stringify(respData.data));
      }
    );
  }

  const storeUserData = (userData) => {
    setUserData(userData);
    getUserWishlist(userData);
    // getSessionKey();
    localStorage.setItem("storedUserData", JSON.stringify(userData));
    //    getCartData();
    history.push("/profilo");

    // per debug
    //let dati = JSON.parse(localStorage.getItem("storedUserData"));
  };

  const logout = () => {
    setUserData(null);
    //setCartData(null);
    //getSessionKey();  // da commentare per mantenere gli oggetti nel carrello
    localStorage.removeItem("storedUserData");
    localStorage.removeItem("carrello");

    // notify logout to ws 
    let params = [
      {name: "session", value: SessionKey},
      {name: "field", value: "id_e_user"},
      {name: "value", value: "0"},
    ];
    wsCall(
      "https://ws.mediatoys.it/carrello/setCartData",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (respData) => {
        //console.log("logout respData:");
        //console.log(respData);
        getCartData();
      }
    );
  };

  // generic WS API call
  async function wsCall(
    url,
    loading,
    setLoading,
    err,
    setErr,
    paramList,
    action
  ) {
    if (loading) return;
    setLoading(true);
    setErr(null);
    try {
      if (g_cfg.debug === true) 
        console.log("WSCALL " + url);
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + Token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();
      if (paramList) {
        paramList.forEach((par) => {
          if (g_cfg.debug === true)
            console.log(par.name + ", " + par.value);
          formdata.append(par.name, par.value);
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          if (g_cfg.debug === true) 
            console.log("TOKEN EXPIRED!");
          getToken();
        } else {
          if (g_cfg.debug === true) {
            console.log("--- error ---");
            console.log(response);
          }
        }
        throw new Error("Network error " + response.status);
      }
      const respData = await response.json();
      if (g_cfg.debug === true)
        console.log(respData);
      action(respData);
      //return respData;
    } catch (error) {
      console.log(error.message);
      setErr(error.message);
    }
    setLoading(false);
  }
  /*
  async function wsCall(url, token, tokenUpdate, paramList, action) {
    if (IsLoading) return;
    setIsLoading(true);
    try {
      console.log("WSCALL");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();
       if (paramList) {
        paramList.forEach((par) => {
          console.log(par.name + ", " + par.value);
          formdata.append(par.name, par.value);
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          console.log("TOKEN ERROR!");
          tokenUpdate();
        }
        throw new Error("Network error " + response.status);
      }
      const respData = await response.json();
      //console.log(respData);
      action(respData);
      //return respData;
    } catch (error) {
      console.log(error.message);
      setNetError(error.message);
    }
    setIsLoading(false);
  }
*/
  function getToken() {
    if (IsTokenLoading) return;
    setIsTokenLoading(true);
    //console.log("getToken(): IN");
    //let url = g_cfg.urlWSBase + "_wsTestOAuth.php";
    let url = g_cfg.urlBase + "tools/_wsGetToken.php";
    //console.log("--- FETCHING TOKEN ---");

    fetch(url, { cache: "no-cache" })
      .then((response) => response.json())
      .then((data) => {
        if (g_cfg.debug === true) {
          console.log("Got token...");
          console.log(data);
        }
        setToken(data);
        setCookie(g_cfg.accessTokenCookieName, data.access_token, 1);
        setIsTokenLoading(false);
      })
      .catch((e) => {
        console.log("errore: " + e.message);
        setToken(null);
        // delete cookie, setting negative expiration date
        setCookie(g_cfg.accessTokenCookieName, "", -100);
        setIsTokenLoading(false);
      });
  }

  async function getSessionKey() {
    if (IsSessionKeyLoading) return;
    setIsSessionKeyLoading(true);
    var myHeaders = new Headers();
    if (g_cfg.debug === true) 
      console.log("newSession() - " + Token.access_token);
    myHeaders.append("Authorization", "Bearer " + Token.access_token);
    myHeaders.append("Accept", "application/json");

    var formdata = new FormData();

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://ws.mediatoys.it/user/nuovasessione", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log(result);
        setSessionKey(result.session);
        setCookie(g_cfg.sessionCookieName, result.session);
        setIsSessionKeyLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        // delete old cookie?
        setSessionKey(null);
        // delete old cookie (if present), setting expired expiration date
        setCookie(g_cfg.sessionCookieName, "", -100);
        setIsSessionKeyLoading(false);
      });
  }

  function mapFilters(filters) {
    const res = {};
    Object.entries(filters).forEach(([k, el]) => {
      var obj = {};
      obj.label = el.label;
      obj.param = el.variable; // nome parametro chiamata WS
      obj.prefix = k.substring(0, 3).toLowerCase(); // prefisso parametro url e nomi campi input
      var values = {};
      el.data_all.forEach((fel) => {
        values[fel.id] = fel;
      });
      obj.values = values;
      res[obj.prefix] = obj; // per match rapido con parametri di input
    });
    //console.log("Res = ");
    //console.log(res);
    return res;
  }

  async function getProductFilters() {
    if (IsFetchingFilters) return;
    setIsFetchingFilters(true);
    try {
      if (g_cfg.debug === true) 
        console.log("FETCHING PRODUCT FILTERS");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + Token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(
        "https://ws.mediatoys.it/product/productFilterList",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          if (g_cfg.debug === true) 
            console.log("TOKEN ERROR!");
          setToken(null);
          setCookie(g_cfg.accessTokenCookieName, "", -100);
        }
        throw new Error("Network error " + response.status);
      }
      const respData = await response.json();
      //console.log(respData);
      setIsFetchingFilters(false);
      setProductFilters(mapFilters(respData));
      //return respData;
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      setIsFetchingFilters(false);
    }
  }

  async function getProvinceList() {
    if (IsLoading) return;
    setIsLoading(true);
    try {
      if (g_cfg.debug === true) 
        console.log("FETCHING PROVINCE LIST");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + Token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(
        "https://ws.mediatoys.it/carrello/ListProvince",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          if (g_cfg.debug === true) 
            console.log("TOKEN ERROR!");
          setToken(null);
          setCookie(g_cfg.accessTokenCookieName, "", -100);
        }
        throw new Error("Network error " + response.status);
      }
      const respData = await response.json();
      //console.log(respData);
      setIsLoading(false);
      if (respData.status === true)
        setProvinceList(respData.data);
      else {
        setProvinceList([]);
        console.log("problema nel recuperare la lista province: "-respData.message)
      }
      //return respData;
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      setIsLoading(false);
    }
  }

  async function getCartData() {
    if (IsFetchingCart) return;
    setIsFetchingCart(true);
    try {
      if (g_cfg.debug === true) 
        console.log("FETCHING CART DATA");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + Token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();
      if (UserData === null) {
        formdata.append("id_utente", "0");
      } else {
        formdata.append("id_utente", UserData.id_e_user);
      }
      formdata.append("session", SessionKey);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(
        "https://ws.mediatoys.it/carrello/cart_detail",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          if (g_cfg.debug === true) 
            console.log("TOKEN ERROR!");
          setToken(null);
          setCookie(g_cfg.accessTokenCookieName, "", -100);
        }
        throw new Error("Network error " + response.status);
      }
      const respData = await response.json();
      //console.log(respData);
      setIsFetchingCart(false);
      setCartData(respData.data);
      //return respData;
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      setIsFetchingCart(false);
    }
  }

  useEffect(() => {
    if (Token && Token.access_token !== "undefined") {
      if (!SessionKey || SessionKey === "undefined") {
        // no session key
        getSessionKey();
      } else {
        // token and session ok => get the cart, if needed (I think it is always needed to reset cart icon in headerbar E.)
        if (!CartData) {
          getCartData();
        }
      }
      if (!ProductFilters) {
        getProductFilters();
      }
      if (!ProvinceList) {
        getProvinceList();
      }
      if (UserData) {
        getUserWishlist(UserData);
      }
    }
  }, [Token, SessionKey]);

  // da https://www.w3schools.com/js/js_cookies.asp
  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // da tabnine.com
  function setCookie(cName, cValue, expHours = 0) {
    var expires = "";
    if (expHours > 0) {
      let date = new Date();
      date.setTime(date.getTime() + expHours * 60 * 60 * 1000);
      expires = "expires=" + date.toUTCString() + "; ";
    }
    document.cookie =
      cName + "=" + cValue + "; " + expires + "path=/; SameSite=None; Secure";
  }

  //if (!Token && !IsLoading && g_cfg.authMode > 0) {
  if (!Token && g_cfg.authMode > 0) {
    if (g_cfg.authMode === 2) {
      // cerca l'access token tra i cookie impostati dal server
      let accessToken = getCookie(g_cfg.accessTokenCookieName);
      if (accessToken.length > 0) {
        // found
        if (g_cfg.debug === true) 
          console.log("Token cookie found " + accessToken);
        let refreshToken = getCookie(g_cfg.refreshTokenCookieName);
        const tkn = {
          type: "cookie",
          access_token: accessToken,
          refresh_token: refreshToken,
        };
        //console.log(tkn);
        setToken(tkn);
      } else {
        if (g_cfg.debug === true) 
          console.log("Token cookie not found");
        getToken();
      }
    } else {
      // altrimenti usa il webservice proxy sul sito
      getToken();
    }
  }

  if (!SessionKey) {
    // cerca la sessione nel cookie apposito
    let sessionToken = getCookie(g_cfg.sessionCookieName);
    if (sessionToken.length > 0) {
      // found
      if (g_cfg.debug === true) 
        console.log("Session from cookie " + g_cfg.sessionCookieName + ": " + sessionToken);
      setSessionKey(sessionToken);
    } else {
      if (g_cfg.debug === true) 
        console.log("SessionKey cookie not found");
    }
  }


  //  if (!Token || !SessionKey || !ProductFilters) {
  if (!Token || !SessionKey || !ProductFilters || !CartData || !ProvinceList) {
    return (
      <div className="spinner">
        <img src="/images/waiting.gif" alt="loading..." />
      </div>
    );
  }

  if (g_cfg.debug === true) {
    console.log("STATUS:");
    console.log(Token);
    console.log(SessionKey);
    console.log(ProductFilters);
    console.log(CartData);
    //console.log(UserData);
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <HeaderBar
          qty={CartData.carrello.totale_prodotti}
          cfg={g_cfg}
          token={Token}
          userData={UserData}
          tokenUpdate={getToken}
          wsCall={wsCall}
          //data={MenuData}
        />

        <Switch>
          <Route path="/" exact>
            <Home
              to="/home"
              cartUpd={setCartData}
              //map={mapItemData}
              map={null}
              cfg={g_cfg}
              token={Token}
              userData={UserData}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              wishlist={Wishlist}
              setWishlist={setWishlist}
              wsCall={wsCall}
            />
          </Route>
          <Route path="/home">
            <Home
              cartUpd={setCartData}
              //map={mapItemData}
              map={null}
              cfg={g_cfg}
              token={Token}
              userData={UserData}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              wishlist={Wishlist}
              setWishlist={setWishlist}
              wsCall={wsCall}
            />
          </Route>

          <Route path="/login">
            <LoginPage
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              sessionUpdate={setSessionKey}
              userUpdate={storeUserData}
              wsCall={wsCall}
            />
          </Route>
          <Route path="/recupero-password">
            <PasswordRecovery
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              wsCall={wsCall}
            />
          </Route>
          <Route path="/profilo/:section">
            <Profile
              cfg={g_cfg}
              cartUpd={setCartData}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              sessionUpdate={setSessionKey}
              userData={UserData}
              wishlist={Wishlist}
              setWishlist={setWishlist}
              userUpdate={storeUserData}
              logout={logout}
              wsCall={wsCall}
            />
          </Route>
          <Route path="/profilo">
            <Profile
              cfg={g_cfg}
              cartUpd={setCartData}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              sessionUpdate={setSessionKey}
              userData={UserData}
              wishlist={Wishlist}
              setWishlist={setWishlist}
              userUpdate={storeUserData}
              logout={logout}
              wsCall={wsCall}
            />
          </Route>
          <Route path="/registrazione">
            <Register
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              sessionUpdate={setSessionKey}
              userUpdate={storeUserData}
              wsCall={wsCall}
            />
          </Route>

          <Route path={"/"+g_cfg.catalogSlug+"/:category/:title/:itemId"}>
            <ProductDetail
              cartUpd={setCartData}
              userData={UserData}
              map={null}
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              wishlist={Wishlist}
              setWishlist={setWishlist}
              wsCall={wsCall}
            />
          </Route>
          <Route path={"/"+g_cfg.catalogSlug+"/:category/:categoryId"}>
            <ProductList
              cartUpd={setCartData}
              userData={UserData}
              //map={mapItemData}
              map={null}
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              filtersList={ProductFilters}
              filtersMap={mapFilters}
              wishlist={Wishlist}
              setWishlist={setWishlist}
              wsCall={wsCall}
            />
          </Route>
          <Route path={"/"+g_cfg.catalogSlug}>
            <ProductList
              cartUpd={setCartData}
              userData={UserData}
              //map={mapItemData}
              map={null}
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              filtersList={ProductFilters}
              filtersMap={mapFilters}
              wishlist={Wishlist}
              setWishlist={setWishlist}
              wsCall={wsCall}
            />
          </Route>
          <Route path="/carrello">
            <ShoppingCart
              cartData={CartData}
              userData={UserData}
              cartUpd={setCartData}
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              userUpdate={setUserData}
              wsCall={wsCall}
              provinceList={ProvinceList}
            />
          </Route>
          <Route path="/thankyou/:cryptedId">
            <ThankYou
              cartData={CartData}
              userData={UserData}
              cartUpd={setCartData}
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              wsCall={wsCall}
            />
          </Route>
          <Route path="/contatti">
            <ContactPage
              cartData={CartData}
              userData={UserData}
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              wsCall={wsCall}
            />
          </Route>

          <Route path="/condizioni-vendita">
            <ConditionsPage
              cartData={CartData}
              userData={UserData}
              cfg={g_cfg}
              token={Token}
              sessionKey={SessionKey}
              tokenUpdate={getToken}
              wsCall={wsCall}
            />
          </Route>
        </Switch>

        <FooterBar
          cfg={g_cfg}
          token={Token}
          sessionKey={SessionKey}
          tokenUpdate={getToken}
          wsCall={wsCall}
        />

        {g_cfg.devTools === true ? <ReactQueryDevtools /> : null}
      </div>
    </QueryClientProvider>
  );
}

export default App;
